/* ==========================================================================
   CONVERSÃO — Casa Flores (16/10/2026)
   1. Pop-up de 5% na primeira compra. O campo de WhatsApp é o formulário de
      contato NATIVO da Shopify, renderizado no theme.liquid ([data-cupom-molde]):
      a loja tem a proteção anti-spam ligada e só aceita o /contact com o token
      do hCaptcha, que a Shopify põe no {% form %} quando a pessoa interage com
      ele. Este arquivo só leva o formulário para dentro do pop-up, valida o
      número antes do envio e lê o resultado no iframe oculto (a página não sai
      do lugar). O cupom é aplicado pelo link nativo /discount/CASA5: a Shopify
      grava um cookie e o checkout já abre com o desconto. O CASA5 foi criado no
      admin: 5%, todas as peças, uma vez por cliente.
   2. "Pedir para hoje": o bloco vem do servidor (product.liquid); aqui só
      some quando a peça é sob consulta (ela já ganha o botão do WhatsApp).
   ES5, sem dependências. Carregado com defer no theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = {
    codigo: 'CASA5',
    whats: '5511911093492',
    atrasoMs: 2000,           /* abre 2 s depois de entrar (pedido do Erik, 16/10)... */
    rolagem: 0.45,            /* ...ou de 45% de rolagem, o que vier antes */
    saidaDepoisMs: 5000,      /* intenção de saída só conta depois de 5 s */
    voltaDias: 7,             /* fechou sem pegar: volta em 7 dias */
    esperaEnvioMs: 25000,     /* tempo para o hCaptcha (e um eventual desafio) */
    chave: 'casaflores.cupom5.v1'
  };

  var script = document.querySelector('script[data-cupom-foto]');
  var FOTO = script ? script.getAttribute('data-cupom-foto') : '';
  var TESTE = /[?&]cupom=abrir\b/.test(location.search);   /* abre na hora, ignora a memória */

  /* ------------------------------------------------ "Pedir para hoje" */
  function hoje() {
    var bloco = document.querySelector('[data-hoje]');
    if (!bloco) return;
    var prazo = document.querySelector('.compra .prazo');
    function sincroniza() {
      /* O app esconde o .prazo (display:none) quando a peça é sob consulta. */
      bloco.hidden = !!(prazo && prazo.style.display === 'none');
    }
    sincroniza();
    if (prazo && window.MutationObserver) {
      new MutationObserver(sincroniza).observe(prazo, { attributes: true, attributeFilter: ['style'] });
    }
  }

  /* ------------------------------------------------------- memória */
  function le() {
    try { return JSON.parse(localStorage.getItem(CFG.chave)) || {}; } catch (e) { return {}; }
  }
  function grava(v) {
    try { localStorage.setItem(CFG.chave, JSON.stringify(v)); } catch (e) {}
  }

  function podeMostrar() {
    if (!document.querySelector('[data-cupom-form]')) return false;   /* sem o formulário nativo, sem pop-up */
    if (window.Shopify && window.Shopify.designMode) return false;
    if (/^\/(cart|checkout|checkouts|challenge|account|password|pages\/checkout)(\/|$)/.test(location.pathname)) return false;
    if (TESTE) return true;
    var m = le();
    if (m.pegou) return false;
    if (m.fechou && (Date.now() - m.fechou) < CFG.voltaDias * 864e5) return false;
    return true;
  }

  /* ------------------------------------------------------- telefone */
  function soDigitos(v) {
    var d = String(v || '').replace(/\D/g, '');
    if ((d.length === 12 || d.length === 13) && d.indexOf('55') === 0) d = d.slice(2);
    return d;
  }
  function valido(d) {
    if (d.length !== 10 && d.length !== 11) return false;
    var ddd = Number(d.slice(0, 2));
    if (ddd < 11 || ddd > 99 || d.charAt(1) === '0') return false;
    if (d.length === 11 && d.charAt(2) !== '9') return false;
    return true;
  }
  function mascara(d) {
    d = d.slice(0, 11);
    if (!d.length) return '';
    if (d.length <= 2) return '(' + d;
    var r = '(' + d.slice(0, 2) + ') ';
    var resto = d.slice(2);
    var corte = d.length === 11 ? 5 : 4;
    if (resto.length <= corte) return r + resto;
    return r + resto.slice(0, corte) + '-' + resto.slice(corte);
  }

  /* ------------------------------------------------------- pop-up */
  var raiz, painel, form, campo, erro, corpoMsg, botao, alvo, passoPede, passoPronto, zapFalha, focoAntes;
  var aberto = false, mostrado = false, enviando = false;

  var X = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>';

  function monta() {
    raiz = document.createElement('div');
    raiz.className = 'cupom';
    raiz.hidden = true;
    raiz.innerHTML =
      '<div class="cupom__veu" data-cupom-fecha></div>' +
      '<div class="cupom__painel" role="dialog" aria-modal="true" aria-labelledby="cupom-t" aria-describedby="cupom-s">' +
        (FOTO ? '<figure class="cupom__foto"><img alt="" width="1200" height="1490" decoding="async" data-src="' + FOTO + '"></figure>' : '') +
        '<div class="cupom__corpo">' +
          '<button class="cupom__fecha" type="button" data-cupom-fecha aria-label="Fechar">' + X + '</button>' +
          '<div data-passo="pede">' +
            '<p class="cupom__olho">Primeira compra</p>' +
            '<h2 class="cupom__t" id="cupom-t">5% na sua primeira peça.</h2>' +
            '<p class="cupom__s" id="cupom-s">Deixe seu WhatsApp e o desconto já entra no pagamento, sem código para lembrar.</p>' +
            '<div data-cupom-slot></div>' +
            '<button class="cupom__agora" type="button" data-cupom-fecha>Agora não</button>' +
          '</div>' +
          '<div data-passo="pronto" hidden>' +
            '<p class="cupom__olho">Pronto</p>' +
            '<h2 class="cupom__t" tabindex="-1">Os 5% já entram no pagamento.</h2>' +
            '<p class="cupom__s">Se o pagamento pedir um código, é este:</p>' +
            '<div class="cupom__codigo"><span class="cupom__codigo-v">' + CFG.codigo + '</span>' +
              '<button class="cupom__copia" type="button" data-cupom-copia>Copiar</button></div>' +
            '<p class="cupom__nota">Vale uma vez por cliente, nas peças compradas pelo site.</p>' +
            '<p class="cupom__nota" data-cupom-zap hidden></p>' +
            '<button class="btn btn--primaria btn--bloco" type="button" data-cupom-fecha>Ver as peças</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(raiz);

    /* Leva o formulário nativo (com os ouvintes que a Shopify já pôs nele)
       para dentro do pop-up. Mover o nó mantém os ouvintes. */
    form.noValidate = true;
    form.setAttribute('target', 'cupom-alvo');
    raiz.querySelector('[data-cupom-slot]').appendChild(form);
    var molde = document.querySelector('[data-cupom-molde]');
    if (molde && molde.parentNode) molde.parentNode.removeChild(molde);

    painel = raiz.querySelector('.cupom__painel');
    passoPede = raiz.querySelector('[data-passo="pede"]');
    passoPronto = raiz.querySelector('[data-passo="pronto"]');
    zapFalha = raiz.querySelector('[data-cupom-zap]');

    raiz.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('[data-cupom-fecha],[data-cupom-copia]') : null;
      if (!t) return;
      if (t.hasAttribute('data-cupom-copia')) copia(t);
      else fecha();
    });
    raiz.addEventListener('keydown', teclado);
    campo.addEventListener('input', function () {
      var d = soDigitos(campo.value);
      campo.value = mascara(d);
      if (campo.getAttribute('aria-invalid') === 'true' && valido(d)) limpaErro();
    });
  }

  function focaveis() {
    return Array.prototype.filter.call(
      painel.querySelectorAll('button,[href],input:not([type="hidden"]),[tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; });
  }

  function teclado(ev) {
    if (ev.key === 'Escape' || ev.key === 'Esc') { ev.preventDefault(); fecha(); return; }
    if (ev.key !== 'Tab') return;
    var f = focaveis();
    if (!f.length) return;
    var primeiro = f[0], ultimo = f[f.length - 1];
    if (ev.shiftKey && (document.activeElement === primeiro || !painel.contains(document.activeElement))) { ev.preventDefault(); ultimo.focus(); }
    else if (!ev.shiftKey && (document.activeElement === ultimo || !painel.contains(document.activeElement))) { ev.preventDefault(); primeiro.focus(); }
  }

  function ocupado() {
    /* Nunca por cima da sacola, do menu, do seletor de entrega ou de um vídeo,
       nem enquanto a pessoa digita (o recado do cartão, por exemplo). */
    if (document.querySelector('.veu[data-aberto]')) return true;
    var a = document.activeElement;
    if (a && (a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' ||
        (a.tagName === 'INPUT' && !/^(button|submit|checkbox|radio|hidden)$/.test(a.type)))) return true;
    return false;
  }

  function tentaAbrir() {
    if (mostrado || aberto) return;
    /* Aba em segundo plano: o navegador pausa o requestAnimationFrame e o
       painel ficaria aberto e invisível. Espera a pessoa voltar. */
    if (document.hidden) {
      document.addEventListener('visibilitychange', function volta() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', volta);
        setTimeout(tentaAbrir, 1200);
      });
      return;
    }
    if (ocupado()) { setTimeout(tentaAbrir, 4000); return; }
    mostrado = true;
    abre();
  }

  function abre() {
    if (!raiz) monta();
    var img = raiz.querySelector('img[data-src]');
    if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    focoAntes = document.activeElement;
    raiz.hidden = false;
    document.body.classList.add('cupom-trava');
    aberto = true;
    var liga = function () { if (aberto) raiz.setAttribute('data-aberto', ''); };
    requestAnimationFrame(function () { requestAnimationFrame(liga); });
    setTimeout(liga, 120);   /* reserva, caso o rAF não venha */
    setTimeout(function () {
      /* No celular o foco vai para o fechar, para o teclado não subir sozinho. */
      var fino = window.matchMedia && matchMedia('(pointer:fine)').matches;
      (fino ? campo : painel.querySelector('.cupom__fecha')).focus();
    }, 60);
  }

  function fecha() {
    if (!aberto) return;
    var m = le();
    if (!m.pegou) { m.fechou = Date.now(); grava(m); }
    raiz.removeAttribute('data-aberto');
    aberto = false;
    document.body.classList.remove('cupom-trava');
    var reduz = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { raiz.hidden = true; }, reduz ? 0 : 280);
    if (focoAntes && focoAntes.focus && document.contains(focoAntes) && focoAntes !== document.body) focoAntes.focus();
  }

  function mostraErro(t) {
    erro.textContent = t;
    campo.setAttribute('aria-invalid', 'true');
    campo.focus();
  }
  function limpaErro() {
    erro.textContent = '';
    campo.removeAttribute('aria-invalid');
  }

  /* O ouvinte é de CAPTURA no document: roda antes dos ouvintes do próprio
     formulário (inclusive o do captcha da Shopify). Número inválido para
     aqui; número válido segue o envio normal da Shopify. */
  function aoEnviar(ev) {
    if (ev.target !== form) return;
    if (enviando) return;                       /* reenvio feito pelo captcha */
    var d = soDigitos(campo.value);
    if (!valido(d)) {
      ev.preventDefault();
      ev.stopPropagation();
      mostraErro('Confira o número: DDD e mais 8 ou 9 dígitos.');
      return;
    }
    limpaErro();
    var bonito = mascara(d);
    campo.value = bonito;
    corpoMsg.value = 'Pediu o cupom ' + CFG.codigo + ' (5% na primeira compra) no pop-up do site.\nWhatsApp: ' + bonito +
      '\nPágina: ' + location.href.split('?')[0];
    enviando = true;
    botao.disabled = true;
    botao.textContent = 'Guardando seus 5%…';

    var falta = 2, contatoOk = false, feito = false;
    function fim() {
      if (--falta) return;
      grava({ pegou: Date.now() });
      if (!contatoOk) {
        /* A loja não confirmou o número (rede, ou a verificação não terminou).
           O cupom vale do mesmo jeito; o link leva o número pela via que a
           casa já atende. */
        zapFalha.innerHTML = 'Para a casa guardar seu número, <a class="cupom__zap" target="_blank" rel="noopener" href="https://wa.me/' +
          CFG.whats + '?text=' + encodeURIComponent('Oi! Peguei o cupom ' + CFG.codigo + ' no site. Meu WhatsApp é ' + bonito + '.') +
          '">mande um oi no WhatsApp</a>.';
        zapFalha.hidden = false;
      }
      passoPede.hidden = true;
      passoPronto.hidden = false;
      raiz.querySelector('[data-passo="pronto"] .cupom__t').focus();
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'cupom_primeira_compra', cupom: CFG.codigo, contato: contatoOk }); } catch (e) {}
    }
    function contato(ok) { if (feito) return; feito = true; contatoOk = ok; fim(); }

    /* 1. O envio. A loja não pode ser aberta dentro de iframe (a resposta fica
          bloqueada e ninguém lê o resultado), então o TRANSPORTE é um fetch
          com o próprio formulário — inclusive o token que o script de captcha
          da Shopify põe nele antes de chamar form.submit(). O captcha segue
          intocado: só o form.submit() DESTE formulário é que manda por fetch. */
    function postaForm() {
      if (!window.fetch || !window.FormData) { HTMLFormElement.prototype.submit.call(form); contato(false); return; }
      fetch(form.getAttribute('action').split('#')[0], { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) { contato(res.ok && res.url.indexOf('contact_posted=true') !== -1); },
              function () { contato(false); });
    }
    form.submit = postaForm;
    /* Sem script de captcha na página (proteção desligada), ninguém segura o
       envio: o ouvinte de BOLHA abaixo vê que nada o impediu e manda ele mesmo. */
    document.addEventListener('submit', function semCaptcha(e2) {
      if (e2 !== ev) return;
      document.removeEventListener('submit', semCaptcha, false);
      if (!e2.defaultPrevented) { e2.preventDefault(); postaForm(); }
    }, false);
    setTimeout(function () { contato(false); }, CFG.esperaEnvioMs);

    /* 1b. O número também vai como ATRIBUTO DO CARRINHO, sem captcha: viaja com
           o pedido e aparece no painel da loja ao lado de "Data da entrega".
           Conferido no ar: sobrevive ao clear/add/update que o app faz antes de
           mandar para o pagamento (o update do app mescla, não apaga). */
    try {
      var ra = new XMLHttpRequest();
      ra.open('POST', '/cart/update.js', true);
      ra.setRequestHeader('Content-Type', 'application/json');
      ra.send(JSON.stringify({ attributes: { 'WhatsApp (cupom 5%)': bonito } }));
    } catch (e2) {}

    /* 2. O cupom fica guardado no navegador para o checkout. */
    var r = new XMLHttpRequest();
    r.open('GET', '/discount/' + encodeURIComponent(CFG.codigo) + '?redirect=%2Fcart.js', true);
    r.timeout = 12000;
    r.onload = r.onerror = r.ontimeout = function () { fim(); };
    r.send(null);
  }

  function copia(b) {
    function ok() { b.textContent = 'Copiado'; setTimeout(function () { b.textContent = 'Copiar'; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(CFG.codigo).then(ok, function () {});
    } else {
      var rg = document.createRange();
      rg.selectNodeContents(raiz.querySelector('.cupom__codigo-v'));
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(rg);
      try { document.execCommand('copy'); ok(); } catch (e) {}
    }
  }

  function arma() {
    if (!podeMostrar()) return;
    form = document.querySelector('[data-cupom-form]');
    campo = form.querySelector('input[type="tel"]');
    erro = form.querySelector('.cupom__erro');
    corpoMsg = form.querySelector('[name="contact[body]"]');
    botao = form.querySelector('button[type="submit"]');
    alvo = document.querySelector('iframe[name="cupom-alvo"]');
    if (!campo || !corpoMsg || !botao || !alvo) return;
    document.addEventListener('submit', aoEnviar, true);

    if (TESTE) { setTimeout(tentaAbrir, 300); return; }
    var t0 = Date.now();
    var timer = setTimeout(tentaAbrir, CFG.atrasoMs);
    function rolou() {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && (scrollY / h) >= CFG.rolagem) { window.removeEventListener('scroll', rolou); clearTimeout(timer); tentaAbrir(); }
    }
    window.addEventListener('scroll', rolou, { passive: true });
    if (window.matchMedia && matchMedia('(pointer:fine)').matches) {
      document.addEventListener('mouseout', function saida(ev) {
        if (ev.relatedTarget || ev.clientY > 0 || Date.now() - t0 < CFG.saidaDepoisMs) return;
        document.removeEventListener('mouseout', saida);
        clearTimeout(timer);
        tentaAbrir();
      });
    }
  }

  function inicia() { hoje(); arma(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
